import classNames from 'classnames';
import React from 'react';
import './styles.scss';

const LineLoader = ({ hide, className }) => (
  <div className={className}>
    <div
      className={classNames('courses-line-loader', hide ? 'courses-line-loader_hide' : 'courses-line-loader_animate')}
    />
  </div>
);

export default LineLoader;
